<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>

      <Input
        label="global.ipAddress"
        id="public_ip_addr"
        placeholder="examples.ip"
        v-model="form.public_ip_addr"
        :state="validateState('public_ip_addr')"
      />
    </b-skeleton-wrapper>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'GatewayVPNClientCreate',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    gatewayId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        public_ip_addr: '',
      },
      loading: false,
    }
  },
  validations: {
    form: {
      public_ip_addr: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }
      this.loading = true

      let params = {
        public_ip_addr: this.form.public_ip_addr,
      }

      ApiService.post(
        `packetbender/netgateways/${this.gatewayId}/vpn/client`,
        params
      )
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.loading = false
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
          this.loading = false
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
